import { isEmail, parsePhoneNumber, ZIP_CODE_REGEX } from '@side/pantry';
import { isEmpty } from 'lodash';
import {
  derivePhoneNumber,
  isValueEqualToCountryPrefix,
} from '@/common/utils/phoneNumber';
import type { Validation } from '../configurations/types';

export const doesFieldValidationApply = (
  validation: Validation,
  cardIndex: number,
) => {
  if (!validation.appliesToIndex || isEmpty(validation.appliesToIndex))
    return true;

  return validation.appliesToIndex.includes(cardIndex);
};

export const invalidEmail = (value?: string) => {
  if (value && isEmail(value)) return false;

  return true;
};

export const isValidPhone = (value?: string | null) => {
  if (!value) {
    return true;
  }

  if (isValueEqualToCountryPrefix(value)) {
    return true;
  }

  return parsePhoneNumber(derivePhoneNumber(value)).validation.isValid;
};

export const invalidZipCode = (value?: number | string) => {
  return !value || !ZIP_CODE_REGEX.test(value.toString());
};
